<template>
  <div id="metahands">
    <div class="banner">
    </div>
    <div class="top_2">
      <div class="h1_title">
        <h1>业务生态</h1>
        <p>以营销与虚拟技术为依托，为品牌提供全新营销可能</p>
      </div>
      <div class="search">
        <div class="search_cont">
          <div class="swiper-container">
            <div class="swiper-wrapper">
              <div class="swiper-slide">
                <div class="search_box">
                  <div class="left">
                    <h1>
                      虚拟数字人
                    </h1>
                    <p>
                      丰富的知识图谱能承担更多的任务，<br />
                      优秀的人机交互提供企业多元化的用户触达模式，<br />
                      基于虚拟人的生态文明建设，<br />
                      更好的生态性将带来更好的商业企业变现能力。
                    </p>
                  </div>
                  <img src="https://static.adjuz.net/asmmaster/img/metahands/metahands_digital_human.png" alt="">
                </div>
              </div>
              <div class="swiper-slide">
                <div class="search_box">
                  <div class="left">
                    <h1>
                      元宇宙空间
                    </h1>
                    <p>
                      通过3D云展厅/展会、人文景区展示、<br />
                      智慧城市建设、数字空间场景应用的打造，<br />
                      建立品牌虚拟数字世界，<br />
                      以用户共建共创，强化品牌认同。
                    </p>
                  </div>
                  <img src="https://static.adjuz.net/asmmaster/img/metahands/metahands_meta_space.png" alt="">
                </div>
              </div>
              <div class="swiper-slide">
                <div class="search_box">
                  <div class="left">
                    <h1>
                      NFT数字艺术藏品
                    </h1>
                    <p>
                      每个NFT都具有独特且唯一的标识，<br />
                      作为收藏品不会有版权纠纷，<br />
                      可以创作出独一无二的数字艺术品，<br />
                      在游戏中的应用掀起GameFi新时代，<br />
                      开辟虚拟经济新赛道。
                    </p>
                  </div>
                  <img src="https://static.adjuz.net/asmmaster/img/metahands/metahands_nft.png" alt="">
                </div>
              </div>
            </div>
            <div class="swiper-pagination"></div>
          </div>
        </div>
      </div>
    </div>
    <footerbom></footerbom>
  </div>
</template>

<script type="text/javascript">
export default {
  data() {
    return {
    };
  },
  computed: {},
  components: {},
  created() { },
  destroyed() { },
  mounted() {
    var swiper = new Swiper(".swiper-container", {
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      slidesPerView: 4,
      paginationClickable: true,
      loop: true,
      slidesPerView: "auto",
      speed: 1000,
      autoplay: {
        disableOnInteraction: false,
        delay: 4000,
      },
    });
  },
  methods: {
  },
};
</script>

<style lang="less" scoped>
#metahands {
  width: 100%;
  .banner {
    width: 100%;
    height: 500px;
    background: url('https://static.adjuz.net/asmmaster/img/metahands/metahands_main.png') no-repeat center center;
    background-size: cover;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: -1px;
  }
  .search {
    width: 100%;
    height: 584px;
    // background: url("./ASO_search1.png") no-repeat center center;
    // background-size: cover;
    .search_cont {
      width: 100%;
      margin: 0px auto 0px;
      height: 550px;
      display: flex;
      img {
        //margin-top: 130px;
        width: 420px;
        height: auto;
      }
    }
  }
  .top_2 {
    background-image: url('https://static.adjuz.net/asmmaster/img/website_5.png');
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    overflow: hidden;
  }
  .h1_title {
    width: 100%;
    text-align: center;
    margin: 60px 0 50px;
    h1 {
      font-size: 36px;
      text-align: center;
      position: relative;
      margin: 60px 0 40px;
      letter-spacing: 4px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333;
      &::after {
        position: absolute;
        content: '';
        width: 70px;
        height: 4px;
        background: #409eff;
        bottom: -16px;
        left: 50%;
        transform: translateX(-50%);
      }
    }
    p {
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #666666;
    }
  }
}
</style>
<style lang="less">
#metahands {
  .swiper-container {
    height: 560px;
  }
  .swiper-pagination {
    .swiper-pagination-bullet {
      width: 37px;
      border-radius: 4px;
      height: 6px;
    }
  }
}
.search_box {
  width: 1200px;
  height: 508px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 0 80px 0px 40px;
  margin: 0 auto;
  .left {
    margin-top: -30px;
  }
  h1 {
    color: #333;
    position: relative;
    line-height: 60px;
    letter-spacing: 3px;
    font-size: 32px;
    font-family: Microsoft YaHei;
    font-weight: bold;
  }
  p {
    font-size: 24px;
    color: #666;
    margin-top: 20px;
    letter-spacing: 2px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 40px;
  }
}
</style>



// WEBPACK FOOTER //
// src/page/metahands/index.vue